import { Component, Output, EventEmitter } from '@angular/core';
import { Child } from '../../models/child';
import { Globals } from '../../services/globals';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'child-info-titlebar',
  templateUrl: './child-info-titlebar.html',
  styleUrls: ['./child-info-titlebar.scss'],
})

export class ChildInfoTitlebar {

  private $local: LocalStorageService = new LocalStorageService();

  /**
   * 아동 변경 시 출력 할 아동 목록
   */
  childrenForChange: Child[] = [];

  /**
   * 공유 정보.
   */
  globals: Globals;

  /**
   * 아동 변경에 대한 event emitter
   */
  @Output('onChildChanged') private $onChildChanged: EventEmitter<any> = new EventEmitter();

  /**
   * 아동 수가 한 명 여부
   */
  isAlone: boolean;

  /**
   * 리스트 노출 여부
   */
  isShowList: boolean = false;

  /**
   * @param {Globals} globals 공유 정보 (DI)
   * @constructor
   */
  constructor(globals: Globals) {
    this.globals = globals;
    // 아동 수 한 명 여부
    this.isAlone = globals.children.length === 1;
  }

  /**
   * 아동 변경 시 출력 할 목록을 갱신함
   */
  updateChildrenForChange() {
    const newChildren: Child[] = [];

    newChildren.push(this.globals.child);
    this.globals.children.forEach((child) => {
      if (this.globals.child !== child) {
        newChildren.push(child);
      }
    });
    this.childrenForChange = newChildren;
  }

  /**
   * 현재 아동 변경
   */
  public changeChild(child: Child) {
    // 공유 정보의 현재 아동을 변경하고 로컬 스토리지에 식별 번호 저장
    this.globals.child = child;
    this.$local.setChildNum(child.num.toString());
    // 아동 변경 이벤트 전파
    this.$onChildChanged.emit(child.num);
  }
}
